import { Box, ButtonGroup, Button } from "@mui/material";
import FullscreenButton from "../../../../utils/button/fullscreenButton";

export default function ViewModeToggle({
  value,
  onChange,
  options = [],
  sx = {},
  onFullscreenOpen,
  ...props
}) {
  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1,
        ...sx,
      }}
    >
      <ButtonGroup variant='outlined' size='small' {...props}>
        {options.map(({ value: optionValue, label, icon }) => (
          <Button
            key={optionValue}
            variant={value === optionValue ? "contained" : "outlined"}
            startIcon={icon}
            onClick={() => onChange(optionValue)}
            sx={{ textTransform: "none" }}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>

      {onFullscreenOpen && (
        <FullscreenButton handleDialogOpen={onFullscreenOpen} />
      )}
    </Box>
  );
}
